export default __webpack_public_path__ + "static/media/service.11784fae.png";